module.exports = __webpack_public_path__ + "img/jmbcircle.39ce61ff.png";